import type { ReactNode } from 'react';
import { InboxIcon } from 'lucide-react';

export function TableEmptyState({
  title,
  description,
}: {
  title: ReactNode;
  description?: ReactNode;
}) {
  return (
    <div className="flex min-h-48 flex-col items-center justify-center px-6 py-10 text-center">
      <InboxIcon aria-hidden="true" className="mb-4 size-8 text-muted-foreground" />
      <div className="text-sm font-medium text-foreground">{title}</div>
      {description && (
        <p className="mt-1.5 max-w-md text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  );
}
